import { SensorsBillingEstimates } from 'src/api'

const usdFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })

export const formatUsd = (value?: number | null): string => (value === null || value === undefined ? '-' : usdFormatter.format(value))

export interface BillingEstimateRow {
  key: keyof SensorsBillingEstimates
  title: string
  hint: string
}

export const billingEstimatesRows: BillingEstimateRow[] = [
  {
    key: 'activatedOver24Months',
    title: 'Active devices activated more than 24 month ago',
    hint: "Active ThingSpace devices activated more than 24 months ago, billed at the tiered rate selected by this bucket's device count"
  },
  {
    key: 'activatedUnder24Months',
    title: 'Active devices activated less than 24 month ago',
    hint: "Active ThingSpace devices activated less than 24 months ago, billed at the tiered rate selected by this bucket's device count"
  },
  {
    key: 'total',
    title: 'Total (active)',
    hint: 'All active ThingSpace devices, including devices without a known activation date; the cost is the sum of both buckets above'
  }
]

export interface BillingEstimatesGridRow extends BillingEstimateRow {
  amount?: number
  ratePerDevice?: number | null
  estimatedCost?: number
}

export const buildBillingEstimatesGridRows = (estimates?: SensorsBillingEstimates): BillingEstimatesGridRow[] =>
  billingEstimatesRows.map((row) => {
    const bucket = estimates?.[row.key]
    return {
      ...row,
      amount: bucket?.amount,
      ratePerDevice: bucket && 'ratePerDevice' in bucket ? bucket.ratePerDevice : undefined,
      estimatedCost: bucket?.estimatedCost
    }
  })
